var render, staticRenderFns
import script from "./Center.vue?vue&type=script&lang=js&"
export * from "./Center.vue?vue&type=script&lang=js&"
import style0 from "./Center.vue?vue&type=style&index=0&id=5759451f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759451f",
  null
  
)

/* custom blocks */
import block0 from "./Center.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./Center.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Center', component.exports)
}
export default component.exports